import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { ExpeditionCoordinate } from '@api/ringil-api.v2';
import { isNotNullOrUndefined } from '@utils/utils';
import useNavigation from '@hooks/useNavigation.tsx';
import { Link } from 'react-router-dom';

interface ComponentProps {
  expeditionCoords?: ExpeditionCoordinate;
}

const LinkedExpBadge: React.FC<ComponentProps> = ({ expeditionCoords }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();

  return (
    <>
      {isNotNullOrUndefined(expeditionCoords) && (
        <Link to={navigation.createNavigationLink(navigation.urlFunctions.createExpeditionDetailForUser(expeditionCoords.expeditionId, expeditionCoords))}>
          <Badge
            type="LinkedExpBadge"
            filled={true}
            value={expeditionCoords.applicationId}
            label={tr(`LinkedExpBadge.title`, `Expedition`)}
            highlightedValue={true}
          ></Badge>
        </Link>
      )}
    </>
  );
};

export default LinkedExpBadge;
